export default __webpack_public_path__ + "static/media/04AW4JUL66.53d35ef0.jpg";